import React from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslationList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import moment from 'moment-timezone';
import { IsWidgetAccessible } from '../../utils/widgetManager';

const SignalTranslationListTable = ({ paginatedData = [], unitId, unitSerialNumber, userProfileWidgets, currentTimezone }) => {
  const isViewAllowed = IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATION_VIEW');

  return (
    <div className={s.wsTableContainer}>
      <Table variant className={s.wsTable}>
        <thead>
          <tr>
            <th>
              <FormattedMessage id="signalTranslation.sensor" defaultMessage="Sensor" />
            </th>
            <th>
              <FormattedMessage id="signalTranslation.signalTranslationComponent" defaultMessage="SignalTranslation Component" />
            </th>
            <th>
              <FormattedMessage id="signalTranslation.status" defaultMessage="Status" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="signalTranslation.signalTranslationDate" defaultMessage="SignalTranslation Date" />
            </th>
            <th className="d-none d-md-table-cell">
              <FormattedMessage id="signalTranslation.assignee" defaultMessage="Assignee" />
            </th>
            <th>
              <FormattedMessage id="signalTranslation.signalTranslationRequired" defaultMessage="SignalTranslation Required" />
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {paginatedData.map(n => {
            return (
              <tr key={n.SignalTranslationId} data-unittest="signalTranslationData">
                <td>{n.ComponentPartName || ''}</td>
                <td>{n.ComponentPartName + '_' + n.SignalTranslationComponentName || ''}</td>
                <td>{n.Status || ''}</td>
                <td className="d-none d-md-table-cell">
                  {n.SignalTranslationDateTime
                    ? moment
                        .unix(n.SignalTranslationDateTime)
                        .tz(currentTimezone)
                        .format('DD-MMM-YYYY HH:mm')
                    : '-'}
                </td>

                <td className="d-none d-md-table-cell">{n.FullName || ''}</td>
                <td>
                  <span className={`${s.dot} ${n.SignalTranslationRequired ? s.dotRed : s.dotGreen}`}></span>{' '}
                  {n.SignalTranslationRequired ? (
                    <FormattedMessage id="signalTranslation.yes" defaultMessage="Yes" />
                  ) : (
                    <FormattedMessage id="signalTranslation.no" defaultMessage="No" />
                  )}
                </td>
                <td>
                  {isViewAllowed ? (
                    <Link to={`/unit/signal-translations/${unitSerialNumber}/view/${unitId}/${n.SignalTranslationId}`}>
                      <Button variant="outline-secondary" className={s.changeButton}>
                        <FormattedMessage id="signalTranslation.view" defaultMessage="VIEW" />
                      </Button>
                    </Link>
                  ) : null}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};


SignalTranslationListTable.propTypes = {
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(SignalTranslationListTable);
